// extracted by mini-css-extract-plugin
export default {"Bar":"Bar--S1BiP","BarContentLabel":"BarContentLabel--MHQRq","BarDetailLabel":"BarDetailLabel--wbGai","BarDetailIcon":"BarDetailIcon--Kv5TG","BarFill":"BarFill--elzEd"};